module.exports = __webpack_public_path__ + "media/src/images/certificates/generic_coa_sample-a51356d8c8ed6fb1f2051d3416d829ce.jpg";